<template>
    <v-container fluid style="background: #eaedf1">
        <v-sheet class="pa-3">
            <v-progress-linear
                color="secondary"
                :value="progress"
                height="20"
                stream
                :buffer-value="progressBuffer"
            ></v-progress-linear>
            <v-window v-model="step">
                <v-window-item :value="1">
                    <Step1 @next="next()" class="mx-auto mt-3 new-campaign-card"/>
                </v-window-item>
                <v-window-item :value="2">
                    <Step2 @next="next()" @prev="prev()" class="mx-auto mt-3 new-campaign-card"/>
                </v-window-item>
                <v-window-item :value="3" class="mx-auto mt-3 new-campaign-card">
                    <Step3 @prev="prev()" />
                </v-window-item>
            </v-window>
        </v-sheet>
    </v-container>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import Step1 from "@/components/loyaltyPanel/newReward/Step1"
import Step2 from "@/components/loyaltyPanel/newReward/Step2"
import Step3 from "@/components/loyaltyPanel/newReward/Step3"
import newReward from "../../../utils/translations/loyaltyPanel/campaigns/newReward";

export default {
    name: "NewReward",

    components: {
        Step1,
        Step2,
        Step3,
    },

    data: () => ({
        maxStep:1
    }),

    computed: {
        ...mapState("loyaltyPanel/campaigns/rewards", [
            "newReward",
            "step"
        ]),

        progress() {
           return this.getProgress(this.step)
        },

        progressBuffer() {
           return this.getProgress(this.maxStep)
        },

        progressColor() {
            let color;

            switch (this.progress) {
                case 16.6:
                    color = "red";
                    break;
                case 33.2:
                    color = "#fced62";
                    break;
                case 49.8:
                    color = "#ffca4f";
                    break;
                case 66.4:
                    color = "#ffac40";
                    break;
                case 83.2:
                    color = "orange";
                    break;
                case 100:
                    color = "green";
            }

            return color;
        }
    },

    methods: {
        
        ...mapActions("loyaltyPanel/campaigns/rewards", [
            "getCampaignTypes"
        ]),
        ...mapMutations("loyaltyPanel/campaigns/rewards",["setCanGoToNextStep", "setStep", "setNewReward"]),

        next(val = null){
            this.setStep( val ||  this.step +1)
            if (this.step > this.maxStep) {
                this.maxStep++
            }
        },

        prev(){
            this.setStep(this.step - 1)
        },
        getProgress(val){
            let lastStep = 3

            return parseInt((val-1) * (100/lastStep))
        }
    },

    watch: {
        maxStep(val){
            this.setCanGoToNextStep(false)
        }
    }
};
</script>

<style scoped>
.border-grey {
    border: 2px solid grey;
}

.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
<style>
.new-campaign-card{
    border: none !important;
    max-width: 1200px;
}
</style>
